module.exports = __webpack_public_path__ + "img/janoo-logo.f48ded66.png";